<template>
  <div class="campanhas-ads-cadastro-vue mt-3">
    <div class="campanhas-ads-cadastro-vue__bootstrap-modals">
      <Modal
        modal-id="modalCampanhasAdsErro"
        :title="errorModalTitle"
        dialog-class="modal-dialog-centered"
      >
        <template #body>
          <p v-if="errorModalMessage" class="mb-2">{{ errorModalMessage }}</p>
          <ul
            v-if="errorModalItems.length"
            class="list-unstyled mb-0 campanhas-ads-cadastro-vue__error-list"
          >
            <li v-for="(row, i) in errorModalItems" :key="i" class="small">
              <template v-if="row.label">
                <strong>{{ row.label }}:</strong>
                {{ row.text }}
              </template>
              <template v-else>{{ row.text }}</template>
            </li>
          </ul>
        </template>
        <template #footer>
          <button type="button" class="btn btn-primary btn-sm" @click="closeErrorModal">Fechar</button>
        </template>
      </Modal>

      <Modal
        modal-id="modalCampanhasAdsExcluir"
        title="Excluir registro"
        dialog-class="modal-dialog-centered"
      >
        <template #body>
          <p v-if="deleteTarget" class="mb-0">
            {{ deleteConfirmText }}
          </p>
        </template>
        <template #footer>
          <Button variant="danger" size="sm" :loading="deleteDeleting" @click="executeDeleteConfirmed">
            {{ deleteDeleting ? "Excluindo…" : "Excluir" }}
          </Button>
          <button
            type="button"
            class="btn btn-secondary btn-sm ml-2"
            :disabled="deleteDeleting"
            data-dismiss="modal"
            @click="closeDeleteConfirmModal"
          >
            Cancelar
          </button>
        </template>
      </Modal>

      <Modal modal-id="modalCampanhasAdsItem" :title="modalTitle" dialog-class="modal-lg">
        <template #body>
          <Input
            v-model="form.titulo"
            name="titulo"
            id="campanhas-ads-titulo"
            label="Título"
            placeholder="Título da campanha"
            required
          />
          <div class="form-group">
            <label class="small mb-1" for="campanhas-ads-observacoes">Observações</label>
            <textarea
              id="campanhas-ads-observacoes"
              v-model="form.observacoes"
              name="observacoes"
              class="form-control"
              rows="3"
            ></textarea>
          </div>
          <div class="mb-3">
            <Check v-model="form.ativo">Ativo</Check>
          </div>
          <div class="mb-3">
            <Check v-model="form.usado_ecommerce">Utilizar no e-commerce</Check>
          </div>

          <div class="mb-3">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <label class="small mb-0">Campos</label>
              <button type="button" class="btn btn-sm btn-outline-primary" @click="adicionarCampo">
                Adicionar campo
              </button>
            </div>
            <div v-if="!form.campos.length" class="text-muted small">Nenhum campo adicionado.</div>
            <div
              v-for="(campoItem, index) in form.campos"
              :key="index"
              class="d-flex align-items-end flex-wrap mb-2"
            >
              <div class="form-group mr-2 mb-0" style="min-width: 200px; flex: 1">
                <label class="small mb-1">Campo</label>
                <input v-model="campoItem.campo" type="text" class="form-control" />
              </div>
              <div class="form-group mr-2 mb-0">
                <label class="small mb-1">Tipo do texto</label>
                <select v-model.number="campoItem.tipo" class="custom-select">
                  <option :value="1">Texto</option>
                  <option :value="2">Texto longo</option>
                </select>
              </div>
              <button
                type="button"
                class="btn btn-sm btn-outline-danger mb-0"
                title="Remover"
                @click="removerCampo(index)"
              >
                <i class="fas fa-trash"></i>
              </button>
            </div>
          </div>

          <div v-if="form.token_campanha" class="border-top pt-3">
            <p class="small text-muted mb-3">Link e HTML da campanha</p>

            <div class="mb-3">
              <label class="small mb-1 d-block">Link</label>
              <div class="d-flex align-items-center">
                <input :value="linkCampanha" type="text" class="form-control form-control-sm mr-2" readonly />
                <button type="button" class="btn btn-sm btn-light flex-shrink-0" @click="copiar(linkCampanha)">
                  <i class="fas fa-copy mr-1"></i>
                  Copiar
                </button>
              </div>
            </div>

            <div class="mb-3">
              <label class="small mb-1 d-block">HTML (logo da loja)</label>
              <div class="d-flex align-items-center flex-wrap">
                <div class="mr-3 mb-2" v-html="htmlLogoLoja"></div>
                <pre class="form-control form-control-sm mr-2 mb-2 small campanhas-ads-cadastro-vue__html-code">{{ htmlLogoLoja }}</pre>
                <button type="button" class="btn btn-sm btn-light flex-shrink-0 mb-2" @click="copiar(htmlLogoLoja)">
                  <i class="fas fa-copy mr-1"></i>
                  Copiar
                </button>
              </div>
            </div>

            <div class="mb-2">
              <label class="small mb-1 d-block">HTML (logo WhatsApp)</label>
              <div class="d-flex align-items-center flex-wrap">
                <div class="mr-3 mb-2" v-html="htmlLogoWhatsapp"></div>
                <pre class="form-control form-control-sm mr-2 mb-2 small campanhas-ads-cadastro-vue__html-code">{{ htmlLogoWhatsapp }}</pre>
                <button type="button" class="btn btn-sm btn-light flex-shrink-0 mb-2" @click="copiar(htmlLogoWhatsapp)">
                  <i class="fas fa-copy mr-1"></i>
                  Copiar
                </button>
              </div>
            </div>

            <p v-if="copiedLabel" class="text-success small mb-0">{{ copiedLabel }}</p>
          </div>

          <p v-if="formError" class="text-danger small mb-0 mt-2">{{ formError }}</p>
        </template>
        <template #footer>
          <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">Cancelar</button>
          <Button variant="primary" size="sm" :loading="saving" @click="saveModal">Salvar</Button>
        </template>
      </Modal>
    </div>

    <div v-if="!localUsuarioPodeCadastro" class="alert alert-warning">
      Somente administradores ou gerentes podem gerenciar estes cadastros.
    </div>

    <div class="d-flex justify-content-between align-items-center mb-3 flex-wrap">
      <h5 class="mb-0"></h5>
      <Button
        v-if="localUsuarioPodeCadastro"
        variant="success"
        size="sm"
        depth
        @click="openEditModal(null)"
      >
        <Icon type="fas" icon="plus" color="white" class="mr-1" />
        Adicionar
      </Button>
    </div>

    <div v-if="loading" class="text-center py-4">Carregando...</div>
    <div v-else class="campanhas-ads-cadastro-vue__datatable-wrap">
      <DataTable
        name="Campanhas ADS"
        :headers="headers"
        :data="items"
        :pesquisa="true"
        :options="tableOptions"
        :itens-per-page-options="[10, 20, 30, 50, 100, -1]"
      >
        <template v-slot:[`item.observacoes`]="{ item }">
          <span :title="item.observacoes || ''">{{ item.observacoes || "-" }}</span>
        </template>
        <template v-slot:[`item.ativo`]="{ item }">
          <span>{{ isAtivo(item) ? "Ativo" : "Inativo" }}</span>
        </template>
        <template v-slot:[`item.usado_ecommerce`]="{ item }">
          <span>{{ isEcommerce(item) ? "Sim" : "Não" }}</span>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <div class="d-flex justify-content-end align-items-center campanhas-ads-cadastro-vue__actions">
            <Button
              v-if="localUsuarioPodeCadastro"
              variant="primary"
              size="sm"
              table
              class="mr-1 mb-1"
              title="Editar"
              @click="openEditModal(item)"
            >
              <i class="fas fa-edit"></i>
            </Button>
            <Button
              v-if="localUsuarioPodeCadastro"
              variant="danger"
              size="sm"
              table
              class="mb-1"
              title="Excluir"
              @click="openDeleteConfirmModal(item)"
            >
              <i class="fas fa-trash"></i>
            </Button>
          </div>
        </template>
      </DataTable>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import DataTable from "../ui/DataTable.vue";
import Input from "../ui/Input.vue";
import Check from "../ui/Check.vue";
import Icon from "../ui/Icon.vue";
import Button from "../ui/Button.vue";
import Modal from "../ui/Modal.vue";

const JSON_HEADERS = {
  Accept: "application/json",
  "Content-Type": "application/json",
  "X-Requested-With": "XMLHttpRequest",
};

const WHATSAPP_SVG =
  '<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" aria-hidden="true"><path fill="#25D366" d="M12 2C6.48 2 2 6.48 2 12c0 1.85.5 3.58 1.37 5.07L2 22l5.07-1.37A9.96 9.96 0 0 0 12 22c5.52 0 10-4.48 10-10S17.52 2 12 2z"/><path fill="#fff" d="M16.7 14.6c-.25-.13-1.47-.72-1.7-.8-.23-.09-.4-.13-.56.13-.17.25-.64.8-.79.97-.15.17-.29.19-.54.06-.25-.13-1.05-.39-2-1.23-.74-.66-1.24-1.47-1.38-1.72-.15-.25-.02-.38.11-.51.11-.11.25-.29.37-.44.13-.15.17-.25.25-.42.08-.17.04-.31-.02-.44-.06-.13-.56-1.35-.77-1.85-.2-.48-.41-.42-.56-.42h-.48c-.17 0-.44.06-.67.31-.23.25-.88.86-.88 2.1 0 1.24.9 2.44 1.03 2.61.13.17 1.77 2.7 4.29 3.79.6.26 1.07.41 1.43.53.6.19 1.15.17 1.58.1.48-.07 1.47-.6 1.68-1.18.21-.58.21-1.08.15-1.18-.06-.1-.23-.16-.48-.29z"/></svg>';

function fieldLabel(key) {
  const map = {
    titulo: "Título",
    observacoes: "Observações",
    ativo: "Ativo",
    usado_ecommerce: "E-commerce",
    campos: "Campos",
    "campos.0.campo": "Campo",
    "campos.0.tipo": "Tipo do texto",
  };
  if (map[key]) {
    return map[key];
  }
  if (String(key).indexOf("campos.") === 0) {
    return "Campos";
  }
  return String(key).replace(/_/g, " ");
}

function bs$(selector) {
  const jq = typeof window !== "undefined" ? window.jQuery || window.$ : null;
  if (!jq) {
    return { modal: () => {} };
  }
  return jq(selector);
}

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

export default {
  name: "CampanhasAdsCadastroApp",
  components: {
    DataTable,
    Input,
    Check,
    Icon,
    Button,
    Modal,
  },
  data() {
    return {
      localApiUrls: {},
      localUsuarioPodeCadastro: false,
      linkBase: "",
      logoLojaUrl: "",
      logoLojaAlt: "WhatsApp",
      items: [],
      loading: false,
      saving: false,
      tableOptions: {
        page: 1,
        itemsPerPage: 30,
      },
      editingId: null,
      form: this.emptyForm(),
      formError: "",
      copiedLabel: "",
      errorModalTitle: "Atenção",
      errorModalMessage: "",
      errorModalItems: [],
      deleteTarget: null,
      deleteDeleting: false,
      headers: [
        { text: "#", value: "id", sortable: true, width: "64px" },
        { text: "Título", value: "titulo", sortable: true },
        { text: "Observações", value: "observacoes", sortable: true },
        { text: "Ativo", value: "ativo", sortable: true, width: "90px" },
        { text: "E-commerce", value: "usado_ecommerce", sortable: true, width: "110px" },
        { text: "Ações", value: "actions", sortable: false, align: "end", width: "88px" },
      ],
    };
  },
  computed: {
    modalTitle() {
      return this.editingId ? "Editar campanha ADS" : "Nova campanha ADS";
    },
    deleteConfirmText() {
      if (!this.deleteTarget) return "";
      const nome = this.deleteTarget.titulo || `#${this.deleteTarget.id}`;
      return `Excluir esta campanha "${nome}"? Ela sairá da listagem.`;
    },
    linkCampanha() {
      if (!this.form.token_campanha || !this.linkBase) {
        return "";
      }
      return this.linkBase + this.form.token_campanha;
    },
    htmlLogoLoja() {
      const href = escapeHtml(this.linkCampanha);
      const nome = escapeHtml(this.logoLojaAlt || "WhatsApp");
      if (this.logoLojaUrl) {
        return `<a href="${href}" target="_blank" rel="noopener noreferrer"><img src="${escapeHtml(
          this.logoLojaUrl
        )}" alt="${nome}" style="height:48px;width:48px;border:0" /></a>`;
      }
      return `<a href="${href}" target="_blank" rel="noopener noreferrer">${nome}</a>`;
    },
    htmlLogoWhatsapp() {
      const href = escapeHtml(this.linkCampanha);
      return `<a href="${href}" target="_blank" rel="noopener noreferrer">${WHATSAPP_SVG}</a>`;
    },
  },
  mounted() {
    const el =
      typeof document !== "undefined"
        ? document.getElementById("campanhas-ads-cadastro-config")
        : null;
    let cfg = {};
    if (el) {
      try {
        cfg = JSON.parse(el.textContent || "{}");
      } catch (e) {
        cfg = {};
      }
    }
    const urls = cfg.apiUrls && Object.keys(cfg.apiUrls).length ? cfg.apiUrls : {};
    this.localApiUrls = urls;
    this.localUsuarioPodeCadastro =
      cfg.usuarioPodeCadastro !== undefined ? !!cfg.usuarioPodeCadastro : false;
    this.linkBase = cfg.linkBase || "";
    this.logoLojaUrl = cfg.logoLojaUrl || "";
    this.logoLojaAlt = cfg.logoLojaAlt || "WhatsApp";

    if (cfg.csrfToken) {
      axios.defaults.headers.common["X-CSRF-TOKEN"] = cfg.csrfToken;
    }
    axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

    this.loadList();
  },
  methods: {
    emptyForm() {
      return {
        titulo: "",
        observacoes: "",
        ativo: true,
        usado_ecommerce: false,
        token_campanha: "",
        campos: [],
      };
    },
    isAtivo(item) {
      const s = item && item.ativo;
      if (s === true || s === 1 || s === "1") return true;
      if (s === false || s === 0 || s === "0") return false;
      return !!s;
    },
    isEcommerce(item) {
      const s = item && item.usado_ecommerce;
      if (s === true || s === 1 || s === "1") return true;
      return false;
    },
    adicionarCampo() {
      this.form.campos.push({ campo: "", tipo: 1 });
    },
    removerCampo(index) {
      this.form.campos.splice(index, 1);
    },
    showErrorModal({ title, message, errors }) {
      this.errorModalTitle = title || "Atenção";
      this.errorModalMessage = message || "";
      this.errorModalItems = [];
      if (errors && typeof errors === "object" && !Array.isArray(errors)) {
        Object.keys(errors).forEach((key) => {
          const msgs = errors[key];
          const arr = Array.isArray(msgs) ? msgs : [msgs];
          const label = fieldLabel(key);
          arr.forEach((m) => {
            if (m != null && String(m).trim() !== "") {
              this.errorModalItems.push({ label, text: String(m) });
            }
          });
        });
      }
      if (!this.errorModalMessage && this.errorModalItems.length) {
        this.errorModalMessage = "Corrija os campos indicados abaixo.";
      }
      this.$nextTick(() => {
        bs$("#modalCampanhasAdsErro").modal("show");
      });
    },
    closeErrorModal() {
      bs$("#modalCampanhasAdsErro").modal("hide");
    },
    openDeleteConfirmModal(item) {
      this.deleteTarget = item;
      this.deleteDeleting = false;
      this.$nextTick(() => {
        bs$("#modalCampanhasAdsExcluir").modal("show");
      });
    },
    closeDeleteConfirmModal() {
      bs$("#modalCampanhasAdsExcluir").modal("hide");
      this.deleteTarget = null;
    },
    async loadList() {
      this.loading = true;
      try {
        const { data } = await axios.get(this.localApiUrls.lista, { headers: JSON_HEADERS });
        this.items = Array.isArray(data) ? data : [];
      } catch (e) {
        this.items = [];
        this.showErrorModal({
          title: "Lista",
          message: "Não foi possível carregar os dados.",
        });
      } finally {
        this.loading = false;
      }
    },
    openEditModal(row) {
      this.formError = "";
      this.copiedLabel = "";
      this.editingId = row ? row.id : null;
      this.form = row
        ? {
            titulo: row.titulo || "",
            observacoes: row.observacoes || "",
            ativo: this.isAtivo(row),
            usado_ecommerce: this.isEcommerce(row),
            token_campanha: row.token_campanha || "",
            campos: Array.isArray(row.campos)
              ? row.campos.map((c) => ({
                  campo: c.campo || "",
                  tipo: Number(c.tipo) || 1,
                }))
              : [],
          }
        : this.emptyForm();
      this.$nextTick(() => {
        bs$("#modalCampanhasAdsItem").modal("show");
      });
    },
    async saveModal() {
      this.formError = "";
      this.saving = true;
      try {
        const payload = {
          titulo: this.form.titulo,
          observacoes: this.form.observacoes,
          ativo: !!this.form.ativo,
          usado_ecommerce: !!this.form.usado_ecommerce,
          campos: this.form.campos.map((c, i) => ({
            campo: c.campo,
            tipo: Number(c.tipo) || 1,
            ordem: i,
          })),
        };
        const base = this.localApiUrls.base;
        if (this.editingId) {
          await axios.put(`${base}/${this.editingId}`, payload, { headers: JSON_HEADERS });
        } else {
          await axios.post(base, payload, { headers: JSON_HEADERS });
        }
        bs$("#modalCampanhasAdsItem").modal("hide");
        await this.loadList();
      } catch (e) {
        const d = e.response && e.response.data ? e.response.data : {};
        if (e.response && e.response.status === 422) {
          this.showErrorModal({
            title: "Dados inválidos",
            message: d.message || "Os dados enviados são inválidos.",
            errors: d.errors,
          });
        } else {
          const msg =
            (typeof d.message === "string" && d.message) ||
            (typeof d.error === "string" && d.error) ||
            "Não foi possível salvar.";
          this.formError = typeof msg === "string" ? msg : JSON.stringify(msg);
        }
      } finally {
        this.saving = false;
      }
    },
    async executeDeleteConfirmed() {
      if (!this.deleteTarget) {
        this.closeDeleteConfirmModal();
        return;
      }
      const id = this.deleteTarget.id;
      this.deleteDeleting = true;
      try {
        await axios.delete(`${this.localApiUrls.base}/${id}`, { headers: JSON_HEADERS });
        this.closeDeleteConfirmModal();
        await this.loadList();
      } catch (e) {
        this.closeDeleteConfirmModal();
        const d = e.response && e.response.data ? e.response.data : {};
        this.showErrorModal({
          title: "Exclusão",
          message:
            (typeof d.message === "string" && d.message) || "Não foi possível excluir este registro.",
        });
      } finally {
        this.deleteDeleting = false;
      }
    },
    copiarFallback(texto) {
      const area = document.createElement("textarea");
      area.value = texto;
      area.setAttribute("readonly", "");
      area.style.position = "fixed";
      area.style.top = "0";
      area.style.left = "0";
      const modal = document.getElementById("modalCampanhasAdsItem");
      const host = modal || document.body;
      host.appendChild(area);
      area.focus();
      area.select();
      const ok = document.execCommand("copy");
      host.removeChild(area);
      if (!ok) {
        throw new Error("copy");
      }
    },
    async copiar(texto) {
      if (!texto) {
        return;
      }
      try {
        if (navigator.clipboard && typeof navigator.clipboard.writeText === "function") {
          await navigator.clipboard.writeText(texto);
        } else {
          this.copiarFallback(texto);
        }
        this.copiedLabel = "Copiado!";
      } catch (e) {
        try {
          this.copiarFallback(texto);
          this.copiedLabel = "Copiado!";
        } catch (err) {
          this.copiedLabel = "";
          this.showErrorModal({
            title: "Copiar",
            message: "Não foi possível copiar.",
          });
        }
      }
    },
  },
};
</script>

<style scoped>
.campanhas-ads-cadastro-vue__error-list li + li {
  margin-top: 0.35rem;
}

.campanhas-ads-cadastro-vue__datatable-wrap ::v-deep .container-fluid {
  padding-left: 0;
  padding-right: 0;
}

.campanhas-ads-cadastro-vue__datatable-wrap ::v-deep table {
  table-layout: fixed;
  width: 100%;
}

.campanhas-ads-cadastro-vue__datatable-wrap ::v-deep th:nth-child(1),
.campanhas-ads-cadastro-vue__datatable-wrap ::v-deep td:nth-child(1) {
  width: 64px;
}

.campanhas-ads-cadastro-vue__datatable-wrap ::v-deep th:nth-child(2),
.campanhas-ads-cadastro-vue__datatable-wrap ::v-deep td:nth-child(2),
.campanhas-ads-cadastro-vue__datatable-wrap ::v-deep th:nth-child(3),
.campanhas-ads-cadastro-vue__datatable-wrap ::v-deep td:nth-child(3) {
  width: 32%;
}

.campanhas-ads-cadastro-vue__datatable-wrap ::v-deep td:nth-child(2),
.campanhas-ads-cadastro-vue__datatable-wrap ::v-deep td:nth-child(3) {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.campanhas-ads-cadastro-vue__datatable-wrap ::v-deep th:nth-child(4),
.campanhas-ads-cadastro-vue__datatable-wrap ::v-deep td:nth-child(4) {
  width: 90px;
}

.campanhas-ads-cadastro-vue__datatable-wrap ::v-deep th:nth-child(5),
.campanhas-ads-cadastro-vue__datatable-wrap ::v-deep td:nth-child(5) {
  width: 110px;
}

.campanhas-ads-cadastro-vue__datatable-wrap ::v-deep th:nth-child(6),
.campanhas-ads-cadastro-vue__datatable-wrap ::v-deep td:nth-child(6) {
  width: 88px;
  max-width: 88px;
  text-align: right;
}

.campanhas-ads-cadastro-vue__actions {
  white-space: nowrap;
}

.campanhas-ads-cadastro-vue__html-code {
  min-width: 200px;
  flex: 1;
  min-height: 5.5rem;
  max-height: 8rem;
  overflow: auto;
  white-space: pre-wrap;
  margin-bottom: 0.5rem;
}
</style>
